import { Component } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LOCAL_API_BASE_URL } from "../../config";

function Whatsapp() {
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const shopHomedata: any = useSelector<any>((state) => state.shopHomeJsonList);
  const location = useLocation();
  const shopURL = window.location.href;
  const isXcelShop =
    shopURL?.includes("xceldrycleaner") ||
    (window.location.hostname === "localhost" &&
      LOCAL_API_BASE_URL?.includes("xceldrycleaner"));
  const isLaundryUp =
    shopURL?.includes("laundryup") ||
    (window.location.hostname === "localhost" &&
      LOCAL_API_BASE_URL?.includes("laundryup"));
  const link = isXcelShop
    ? "https://wa.me/442074732846"
    : isLaundryUp
    ? "https://wa.me/447880913200"
    : settingsData?.WebsiteSettings?.social_link10;
  console.log("shopHomedata",shopHomedata)
  const url = location.pathname;
  const splitURL: any = url.toString().split("/");
  //let link;
  // if (settingsData?.template == 1) {
  //   if (splitURL[1] != "shop" && splitURL[1] != "edit-shop-home") {
  //     link =
  //       homedata?.theme_1?.home?.footer?.footer_section?.social_media?.whatsapp
  //         ?.whatsapp_link;
  //   } else {
  //     link =
  //       shopHomedata?.jsonData?.theme_1?.home?.footer?.footer_section
  //       ?.social_media?.whatsapp?.whatsapp_link;
  //   }
  // } else if (settingsData?.template == 2) {
  //   if (splitURL[1] != "shop" && splitURL[1] != "edit-shop-home") {
  //     link =
  //       homedata?.theme_2?.home?.footer?.footer_section?.social_media?.whatsapp
  //         ?.whatsapp_link;
  //   } else {
  //     link =
  //       shopHomedata?.theme_2?.home?.footer?.footer_section
  //       ?.social_media?.whatsapp?.whatsapp_link;
  //   }
  // } else if (settingsData?.template == 3) {
  //   if (splitURL[1] != "shop" && splitURL[1] != "edit-shop-home") {
  //     link =
  //       homedata?.theme_3?.home?.footer?.footer_section?.social_media?.whatsapp
  //         ?.whatsapp_link;
  //   } else {
  //     link =
  //       shopHomedata?.theme_3?.home?.footer?.footer_section?.social_media?.whatsapp?.whatsapp_link;
  //   }
  // } else if (settingsData?.template == 4) {
  //   if (splitURL[1] != "shop" && splitURL[1] != "edit-shop-home") {
  //     link =
  //       homedata?.theme_4?.home?.footer?.social_media?.whatsapp?.whatsapp_link;
  //   } else {
  //     link =
  //       shopHomedata?.theme_4?.home?.footer?.social_media
  //       ?.whatsapp?.whatsapp_link;
  //   }
  // } else if (settingsData?.template == 5) {
  //   if (splitURL[1] != "shop" && splitURL[1] != "edit-shop-home") {
  //     link =
  //       homedata?.theme_5?.home?.footer?.footer_section?.social_media?.whatsapp
  //         ?.whatsapp_link;
  //   } else {
  //     link =
  //       shopHomedata?.theme_5?.home?.footer?.footer_section?.social_media
  //         ?.whatsapp?.whatsapp_link;
  //   }
  // } 
  console.log("link",settingsData?.templ)
  const isTemplateFive = settingsData?.template == 5;
  return (
    <>
      {splitURL[1] !== "maintenance" && (
        <>
        {link ? (
          <div className={`link-whatsapp ${isTemplateFive ? "link-whatsapp-pill" : ""} ${isLaundryUp ? "link-whatsapp-stacked" : ""}`}>
              <a target="blank" href={`${link}`}>
                <span className="link-whatsapp-icon">
                  <i className="fab fa-whatsapp"></i>
                </span>
                {(isTemplateFive || isLaundryUp) && (
                  <span className="link-whatsapp-text">Book on WhatsApp</span>
                )}
              </a>
          </div>
        ) : (
          <></>
        )}
        </>
      )}
    </>
  );
}

export default Whatsapp;
